import styled from 'styled-components';
import { SuiContainer } from '@splashthat/sui';

import { baseFontSize, headlineXxlFontSize, bodyFontWeight } from 'common/styles/typography';
import { colorAppSecondaryText } from 'common/styles/colors';
import { containerPaddingMl, baseSpacer } from 'common/styles/variables';

export const PageContainerStyled = styled(SuiContainer)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 ${containerPaddingMl};
    font-size: ${baseFontSize};
    min-width: 320px; // FIXME this should be part of a breakpoint variable 'small'
    text-align: center;
}
`;

export const StyledTitle = styled.h1`
    font-size: ${headlineXxlFontSize};
    font-weight: ${bodyFontWeight};
    margin-bottom: ${baseSpacer};
`;

export const FooterStyled = styled.footer`
    position: fixed;
    bottom: 0;
    padding-bottom: ${containerPaddingMl};
`;

export const LogoContainerStyled = styled(SuiContainer)`
    width: 140px; // FIXME Magic number, maybe create a set of fixed logo sizes?
    margin: auto;
`;

export const ParagraphStyled = styled.p`
    color: ${colorAppSecondaryText};
`;
